import { TableButton } from "components/TableButton";
import React from "react";
import { Trash } from "react-feather";

export const RemoveButton = ({ removeHandler }) => (
  <TableButton Icon={Trash} onClick={removeHandler} />
);
